/** Missing source files stay visible during migration review. */
export default function FileAvailability({ file }) {
  const status = file?.metadata?.legacy?.contentStatus;
  if (!status || status.startsWith('available')) return null;
  return (
    <span className="shrink-0 text-xs text-amber-700" title="The database record was imported, but its file content is not available in this local copy.">
      {status === 'copy_pending' ? 'Copy pending' : 'File unavailable'}
    </span>
  );
}
